import { render, staticRenderFns } from "./BrowseDaichoKakuShin.vue?vue&type=template&id=268ac47b&scoped=true&"
import script from "./BrowseDaichoKakuShin.vue?vue&type=script&lang=js&"
export * from "./BrowseDaichoKakuShin.vue?vue&type=script&lang=js&"
import style0 from "./BrowseDaichoKakuShin.vue?vue&type=style&index=0&id=268ac47b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268ac47b",
  null
  
)

export default component.exports